//INITIAL FLOW
import * as types from "./actionTypes";

export const setShowUnlockCalculations = (showUnlockCalculations) => ({
  type: types.SET_SHOW_UNLOCK_CALCULATIONS,
  payload: {showUnlockCalculations}
});

export const setUnlockCalculationsStep = (unlockCalculationsStep) => ({
  type: types.SET_UNLOCK_CALCULATIONS_STEP,
  payload: {unlockCalculationsStep}
});

export const showUnlockCalculationsCartItems = (showCartItems) => ({
  type: types.SHOW_UNLOCK_CALCULATIONS_CART_ITEM,
  payload: {showCartItems}
});

export const showUnlockCalculationsTotalItems = (showTotalItems) => ({
  type: types.SHOW_UNLOCK_CALCULATIONS_TOTAL_ITEM,
  payload: {showTotalItems}
});

export const setShowUnlockCalculationsTutorial = (showUnlockCalculationsTutorial) => ({
  type: types.SHOW_UNLOCK_CALCULATIONS_TUTORIAL,
  payload: {showUnlockCalculationsTutorial}
});

export const setUnlockCalculationsTutorialStep = (unlockCalculationsTutorialStep) => ({
  type: types.SET_UNLOCK_CALCULATIONS_TUTORIAL_STEP,
  payload: {unlockCalculationsTutorialStep}
});

export const setUnlockCalculationsTutorialFinished = (unlockCalculationsTutorialIsFinished) => ({
  type: types.SET_UNLOCK_CALCULATIONS_TUTORIAL_FINISHED,
  payload: {unlockCalculationsTutorialIsFinished}
});
